import React from "react";
import "./timeline.css";

import { useTranslation } from "react-i18next";



const Timeline = () => {
     const { t } = useTranslation();
    return (
        <div className="timeline-wrapper">
            <div className="timeline-line"></div>
            <div className="timeline-item left">
                <div className="timeline-box">
                     <img src="./images/booking.png" alt="Booking" className="card-image"  style={{width:'30%'}} />
                    <h4> {t("vh-1")}</h4>
                    <p>
                        {t("vd-1")}
                    </p>
                </div>
            </div>

            <div className="timeline-item right">
                <div className="timeline-box">
                    <img src="./images/booking.png" alt="Booking" className="card-image"  style={{width:'30%'}} />
                    <h4>{t("vh-2")}</h4>
                    <p>
                      {t("vd-2")}
                    </p>
                </div>
            </div>

            <div className="timeline-item left">
                <div className="timeline-box">
                    <img src="./images/booking.png" alt="Booking" className="card-image"  style={{width:'30%'}} />
                    <h4>{t("vh-3")}</h4>
                    <p>{t("vd-3")}</p>
                </div>
            </div>

            <div className="timeline-item right">
                <div className="timeline-box">
                    <img src="./images/booking.png" alt="Booking" className="card-image"  style={{width:'30%'}} />
                    <h4>{t("vh-4")}</h4>
                    <p>
                        {t("vd-4")}
                    </p>
                </div>
            </div>

            <div className="timeline-item left">
                <div className="timeline-box">
                    <img src="./images/booking.png" alt="Booking" className="card-image"  style={{width:'30%'}} />
                    <h4>{t("vh-5")}</h4>
                    <p>
                        {t("vd-5")}
                    </p>
                </div>
            </div>

            <div className="timeline-item right">
                <div className="timeline-box">
                    <img src="./images/booking.png" alt="Booking" className="card-image"  style={{width:'30%'}} />
                    <h4>{t("vh-6")}</h4>
                    <p>
                        {t("vd-6")}
                    </p>
                </div>
            </div>
            <div className="timeline-item left">
                <div className="timeline-box">
                    <img src="./images/booking.png" alt="Booking" className="card-image"  style={{width:'30%'}} />
                    <h4>{t("vh-7")}</h4>
                    <p>
                        {t("vd-7")}
                    </p>
                </div>
            </div>
            <div className="timeline-item right">
                <div className="timeline-box">
                    <img src="./images/booking.png" alt="Booking" className="card-image"  style={{width:'30%'}} />
                    <h4>{t("vh-8")}</h4>
                    <p>
                        {t("vd-8")}
                    </p>
                </div>
            </div>
            <div className="timeline-item left">
                <div className="timeline-box">
                    <img src="./images/booking.png" alt="Booking" className="card-image"  style={{width:'30%'}} />
                    <h4>{t("vh-9")}</h4>
                    <p>
                       {t("vd-9")}
                    </p>
                </div>
            </div>
        </div>
    );
};

export default Timeline;
